import { useParams } from "react-router-dom";
import { decodeBase64UUID } from "src/utils";

/**
 * The id of the account whose pages are displayed, read from the route uuid;
 * undefined outside an account's pages or when the uuid does not decode.
 */
export function useDisplayedAccountId(): string | undefined {
  const { uuid } = useParams();

  if (!uuid) {
    return undefined;
  }

  // CurrentAccountWrapper runs its children's hooks before the account query
  // answers, so a malformed uuid must not crash where the account query
  // failure shows ErrorGlobal today.
  try {
    const { accountId } = decodeBase64UUID(uuid);

    return typeof accountId === "string" ? accountId : undefined;
  } catch {
    return undefined;
  }
}
